import { QueryClient } from '@tanstack/react-query'

class SharedQueryClient extends QueryClient
{
    static #instance: QueryClient

    private constructor ()
    {
        super()
    }

    public static get instance (): QueryClient
    {
        if (!SharedQueryClient.#instance) {
            SharedQueryClient.#instance = new QueryClient({
                defaultOptions: {
                    queries: {
                        gcTime: 1000 * 60 * 5,
                        staleTime: 1000 * 60 * 5,
                        enabled: typeof window === 'undefined',
                    },
                },
            })
        }

        return SharedQueryClient.#instance
    }
}

export const sharedQueryClient = SharedQueryClient.instance